(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/service/draws-service.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/service/draws-service.js');
'use strict';

const isServer = typeof exports === 'object';
let logger;
let trinidad;
if (isServer) {
  trinidad = require('@svenskaspelab/trinidad-core').core;
  logger = trinidad.logger('arena: wagers-service');
} else {
  trinidad = svs.core;
  logger = svs.arena.logger;
}
const fetchDrawsAsync = async () => new Promise((resolve, reject) => {
  try {
    svs.core.jupiter.get(['/draw/1/lotto/draws', '/draw/2/eurojackpot/draws', '/draw/1/keno/draws', '/draw/1/vikinglotto/draws', '/draw/1/jackpots'], response => {
      if (response && Array.isArray(response.responses)) {
        resolve(response.responses);
      }
    });
  } catch (err) {
    logger.warn('Error when fetching multiple products draws', err);
    reject(err);
  }
});
const exportedFunctions = {
  fetchDrawsAsync
};

if (isServer) {
  module.exports = exportedFunctions;
} else {
  svs.arena.service.drawsService = exportedFunctions;
}

 })(window);